import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Reason from './Reason';
import reasonTypeDispatch from '../../../../../../Store/AssetManagement/ReasonType/ReasonTypeDispatch'
import RequisitionAction from '../../../../../../Store/Component/Requisition/RequisitionAction'
import { resetReason, resetReasonDealerdetail } from "client/utils/RequisitionUtil";
import RequisitionValidation from "../../RequisitionValidation"
import { CONSTANTS } from "client/utils/constants";
import { getVendorDetails } from 'Store/Organization/VendorDetails/VendorDetailsAction';

const ItemDetailsContainer = (props: any) => {

    //prop
    const reason = props.reason

    ///dispatch
    const dispatch = useDispatch();
    const dispatchRequisitionTypeDropdown = reasonTypeDispatch.dispatchGetReasonType(dispatch);

    ///selectors
    const { reasonTypeDropdown, requestList, productionVehicleList, reasonList, showItemDetails, isAddToCartClick, isDealerSameForAllFlag }: any = useSelector((state?: any) => ({
        reasonTypeDropdown: state.ReasonType.reasonTypeDropDown,
        requestList: state.RequisitionReducer.requestList,
        productionVehicleList: state.RequisitionReducer.productionVehicleList,
        reasonList: state.RequisitionReducer.reasonList,
        showItemDetails: state.RequisitionReducer.showItemDetails,
        isAddToCartClick: state.RequisitionReducer.isAddToCartClick,
        isDealerSameForAllFlag : state.RequisitionReducer.isDealerSameForAllFlag
    }));

    

    //local state
    const [requestListTemp, setRequestListTemp] = useState([]);
    const [productionVehicleListTemp, setProductionVehicleListTemp] = useState([]);
    const [reasonListTemp, setReasonListTemp] = useState([]);
    const [query, setQuery] = useState('');
   
    // const initializeItemChangeFlag = {
    //     ReasonChange: false,
    //     ShipToDealerChange: false
    // }
    // const [itemChangeFlag, setItemChangeFlag] = useState<any>(initializeItemChangeFlag);
    // const [reasonValue, setReasonValue] = useState<any>();

   
    const reasonRef = useRef<any>([]);

    useEffect(() => {
        dispatchRequisitionTypeDropdown()
        reasonRef.current[0]?.focus();
    }, [])

    useEffect(() => {
        let timeOutId: any;
        if (query) {
            if (reason?.reasonType !== 'Growth') {
                timeOutId = setTimeout(() => props.plannedRef.current[0]?.focus()
                    , 1300);
            }
            else {
                timeOutId = setTimeout(() => props.plannedRef.current[9]?.focus()
                    , 1300);
            }

            return () => clearTimeout(timeOutId);
        }
    }, [query]);



    useEffect(() => {
        setRequestListTemp(requestList);
        setProductionVehicleListTemp(productionVehicleList);
        setReasonListTemp(reasonList);
    }, [requestList, productionVehicleList, reasonList])


    ///Modified dropDown values as required
    const reasonItem: any = reasonTypeDropdown?.map((item: any) =>
        ({ text: item.text, value: item.value, label: item.text, key: item.value })
    );

    
    

    
   

   

    const onChangeReasonType = (e: any, item: any, reason: any) => {
        dispatch(getVendorDetails(''))
        dispatch(RequisitionAction.setIsChangesOccured(true))
        let isValidToResetAll = reason?.isDisabled
        let requestListTemp1 = reasonList?.length > 0 ? JSON.parse(JSON.stringify(reasonList)) : [];
        for (let i = 0; i < requestListTemp1.length; i++) {
            if(requestListTemp1[i]?.requestType === CONSTANTS?.MANAGED_EQUIPMENT && !isValidToResetAll && isDealerSameForAllFlag && reason?.requestType === CONSTANTS?.MANAGED_EQUIPMENT){
                requestListTemp1[i] = resetReasonDealerdetail(requestListTemp1[i]);
            }
            if (requestListTemp1[i]?.reasonIndex === reason?.reasonIndex) {
                //onChange of reason Don't reset linked attachments - 191101
                const reasonAttachments = requestListTemp1[i]?.attachments;
                if(reason?.requestType !== CONSTANTS.MANAGED_EQUIPMENT || !isValidToResetAll){
                requestListTemp1[i] = resetReason(requestListTemp1[i]);
                requestListTemp1[i] = resetReasonDealerdetail(requestListTemp1[i]);
                }else if(isValidToResetAll && reason?.requestType === CONSTANTS.MANAGED_EQUIPMENT){
                    requestListTemp1[i] = resetReason(requestListTemp1[i]);
                }
                requestListTemp1[i].reasonTypeId = item.value;
                requestListTemp1[i].reasonType = item.text;
                requestListTemp1[i].attachments = reasonAttachments;
                if (item.text === CONSTANTS.REASON_GROWTH) {
                    if (requestListTemp1[i]?.requestType === CONSTANTS.PRODUCTION_VEHICLE) {
                        requestListTemp1[i].newEmployeeBusiness = CONSTANTS.NEW_BUSINESS
                        requestListTemp1[i].jobIdOrEmpIdError = " ";
                    }
                    else if (requestListTemp1[i]?.requestType === CONSTANTS.MANAGEMENT_VEHICLE) {
                        requestListTemp1[i].newEmployeeBusiness = CONSTANTS.NEW_EMPLOYEE
                    }
                }
                let responseReason = RequisitionValidation.ValidateReason({...requestListTemp1[i]});
                requestListTemp1[i] = responseReason;         
            }
        }

        dispatch(RequisitionAction.setIReason(requestListTemp1))
        dispatch(RequisitionAction.setIsReasonChange(true));
        dispatch(RequisitionAction.setIsAddToCartClick(false));

        if (item.key != null) {
            reasonRef.current[1]?.focus()
        }
    }

    const onChangeDealer = (e: any, item: any, reason: any) => {
        dispatch(RequisitionAction.setIsChangesOccured(true))
        // let name = item?.target?.name
        // let shipToLocationValidation = validation(name, item)
        // setItemChangeFlag({ ...itemChangeFlag, ShipToDealerChange: true })
        // let isValid = ValidateShipToLocation(item.target?.value)

        let requestListTemp1 = reasonList?.length > 0 ? JSON.parse(JSON.stringify(reasonList)) : [];
        // let isShipLocationValid = reasonValidCheck(shipToLocationValidation)
        for (let i = 0; i < requestListTemp1.length; i++) {
            if (requestListTemp1[i]?.reasonIndex === reason?.reasonIndex) {
                requestListTemp1[i].shipToLocation = item.target.value;
               
                let responseReason = RequisitionValidation.ValidateReason({...requestListTemp1[i]});
                requestListTemp1[i] = responseReason;
            }
        }

        // console.info(item,'item ')
        dispatch(RequisitionAction.setIReason(requestListTemp1))
        if (item) {
            setQuery(item);
        }
    }

    return (
        <Reason
            reasonItem={reasonItem}
            onChangeReasonType={onChangeReasonType}
            onChangeDealer={onChangeDealer}
            requestList={requestListTemp}
            productionVehicleList={productionVehicleListTemp}
            reasonList={reasonListTemp}
            showItemDetails={showItemDetails}
           
            isAddToCartClick={isAddToCartClick}
            reason={reason}
            reasonRef={reasonRef}
            plannedRef={props.plannedRef}
        // reasonValue = {reasonValue}
        />
    )
}

export default ItemDetailsContainer;
